import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { displayToastSuccess } from '@/helpers/display-toast';
import { useApiError } from '@/modules/common/hooks/use-api-error';

import { createRequestedIntegrations } from '../api/requested-integrations.api';
import { CreateRequestedIntegrationsRequest } from '../types/request/requested-integrations';

export const useCreateRequestedIntegrations = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('authenticated.onboarding.integrations');
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: (data: CreateRequestedIntegrationsRequest) => createRequestedIntegrations(data),
    onSuccess: () => {
      displayToastSuccess(t('toast.requestSuccess'));
      onSuccess?.();
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(error, 'toast.requestError');
    },
  });
};
